// extracted by mini-css-extract-plugin
export default {"screen-container":"ScreenContainer_screen-container__qti+3"};